var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 2.66406V16.6641H2.50024V2.66406H16.5002ZM17.6002 0.664062H1.40024C0.900244 0.664062 0.500244 1.06406 0.500244 1.56406V17.7641C0.500244 18.1641 0.900244 18.6641 1.40024 18.6641H17.6002C18.0002 18.6641 18.5002 18.1641 18.5002 17.7641V1.56406C18.5002 1.06406 18.0002 0.664062 17.6002 0.664062ZM8.50024 4.66406H14.5002V6.66406H8.50024V4.66406ZM8.50024 8.66406H14.5002V10.6641H8.50024V8.66406ZM8.50024 12.6641H14.5002V14.6641H8.50024V12.6641ZM4.50024 4.66406H6.50024V6.66406H4.50024V4.66406ZM4.50024 8.66406H6.50024V10.6641H4.50024V8.66406ZM4.50024 12.6641H6.50024V14.6641H4.50024V12.6641Z",
    fill: "#8126DB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.95cf6f025f774c622f334a2e84f4dae3.svg";
export { ForwardRef as ReactComponent };